import { updateItemInCollection } from "directus/src/operations";

export async function updateQuestion({ item, questionId }) {
  try {
    const data = await updateItemInCollection("survey_questions", questionId, item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
